import styled from 'styled-components';
import { BorderColor, SurfaceColor } from '../../../styles/global/css/Utils';
import { PopupWrapper } from '../../popup/style/Style';

interface ContainerProps {
	backgroundColor?: string
	height?: string
	borderBottom?: boolean
}

const Container = styled.div<ContainerProps>`
    background-color: ${p => p.backgroundColor ? p.backgroundColor : SurfaceColor};
    width: 100%;
    min-height: ${p => p.height ? p.height : '60px'};
    height: ${p => p.height ? p.height : '60px'};
    box-sizing: border-box;
    ${p => p.borderBottom ? `border-bottom: 1px solid ${BorderColor};` : ''}
    display: flex;
    align-items: center;
    z-index: 10;
    justify-content: space-between;
    gap: 10px;
    && *:not(.Pinnable-Title):not(${PopupWrapper} *) {
        font-size: 12px;
    }
`;

const LeftContainer = styled.div`
    display: block;
    margin-left: 10px;
    height: 100%;
    display: flex;
    flex-direction: row;
    align-content: center;
    align-items: center;
    gap: 6px;
`;

const RightContainer = styled.div`
    display: block;
    margin-right: 4px;
    height: 100%;
    display: flex;
    flex-direction: row;
    align-content: center;
    align-items: center;
    gap: 6px;
`;

export {
	Container,
	LeftContainer,
	RightContainer
};
